module.exports = __webpack_public_path__ + "assets/img/72086b7b73585d7d597fce601b4cfe3b.png";